/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/types/empty_filters.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/**
 * EmptyFilters: The empty filters type shared by remote lookup providers that declare no filters.
 *
 * @see [ruby definition](../../../../../../../lib/shared/braze/remote_lookup/types/empty_filters.rb)
 */
export const emptyFiltersSchema = z.strictObject({});

/**
 * EmptyFilters: The empty filters type shared by remote lookup providers that declare no filters.
 *
 * @see [ruby definition](../../../../../../../lib/shared/braze/remote_lookup/types/empty_filters.rb)
 */
export const emptyFiltersOutputSchema = z.object({});
